import { useEventListener } from '@vueuse/core';
import { GeneralModal } from '@/views/components/modals/GeneralModal';

const MODAL_ID = 'fact-check-modal-component';
const TRIGGER_SELECTOR = '.modal-fact-check-component__trigger';
class FactCheckModal extends GeneralModal {
    constructor() {
        super({
            modalId: MODAL_ID,
            triggerSelector: TRIGGER_SELECTOR,
            modalContentOverflow: 'auto',
        });
    }
}

const factCheckModal = new FactCheckModal();

useEventListener(document, 'DOMContentLoaded', () => {
    factCheckModal.initialize();
});
